import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Axios from 'axios';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import isBoolean from 'lodash/isBoolean';
import getPath from 'lodash/get';
import head from 'lodash/head';
import { bindActionCreators } from 'redux';
import UserCreditCard from './UserCreditCard';
import UserEmail from './UserEmail';
import UserPassword from './UserPassword';
import AvatarUploader from '../dashboard/components/soundcast/imageart';
import AlertDialog from '../dashboard/components/custom_dialog';
import { FullContentWrapper, FullContentSection, LoadingWrapper } from '../../styles/styled';
import { getUserSessionIdtoken } from '../../helpers/userSession';
import { signoutUser } from '../../actions/index';
import {
  ProfileContainer,
  InputLabel,
  InputText,
  InputEmail,
  FacebookLine,
  StripeMiniLogo,
  CreditCardLine,
  ChangeEmailLine,
  ChangePasswordLine,
  DeleteAccountLine,
  SaveButton,
  CreatePlanButton,
  RemoveButton,
} from './styled';
import Loading from '../../components/Loading';
import {
  userSession,
  verifyUserSession,
  isUserSessionHasFacebookAuth,
} from '../../helpers/userSession';
import ImageCropModal from '../../components/ImageCropModal';
import AlertConfirmDialog from '../../components/AlertConfirmDialog';
import Footer from '../../components/footer';
import { SoundwiseHeader } from '../../components/soundwise_header';
import Colors from '../../styles/colors';
import { authManager } from '../../helpers/managers';

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      pic_url: '',
      providerId: '',
      loadingCustomer: false,
      isCustomerLoaded: false,
      card: {},
      saving: false,
      removing: false,
      imagecrop: {
        show: false,
        onCrop: () => {},
        onClose: () => {},
        file: null,
      },
    };

    this.saveProfile = this.saveProfile.bind(this);
    this.removeAccount = this.removeAccount.bind(this);
    this.createPublisherPlan = this.createPublisherPlan.bind(this);
    this.onInputStateChange = this.onInputStateChange.bind(this);
    this.openImageCropModal = this.openImageCropModal.bind(this);
    this.closeImageCropModal = this.closeImageCropModal.bind(this);
    this.initFilepondImageCropperFor = this.initFilepondImageCropperFor.bind(this);
  }

  componentDidMount() {
    if (process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'staging') {
      console.log('Stripe: setting test key');
      Stripe.setPublishableKey('pk_test_BwjUV9yHQNcgRzx59dSA3Mjt');
    } else {
      Stripe.setPublishableKey('pk_live_rR36Qeypo5CrbG1FKgE1XdlL');
    }

    this.loadUserProfileData();
  }

  componentWillReceiveProps(nextProps) {
    const {
      userInfo: { id },
    } = this.props;
    const {
      userInfo: { id: nid, email },
    } = nextProps;
    if (userSession.ready && id !== nid) {
      this.loadUserProfileData(nextProps);
    } else {
      if (
        !isEmpty(this.state.email) &&
        !isEmpty(email) &&
        !isEqual(this.state.email, head(email))
      ) {
        this.setState({ email: head(email) });
      }
    }
  }

  async loadUserProfileData(props = {}) {
    props = !isEmpty(props) ? props : this.props;

    try {
      await verifyUserSession();
    } catch (e) {
      props.history.push('/signin');
    }

    const { userInfo, history } = props;
    if (!('id' in userInfo)) {
      return false;
    }

    const { firstName, lastName, email, pic_url, stripe_id = '' } = userInfo;

    // facebook auth transition
    const user = authManager.getCurrentUser();

    const hasFacebookAuth = await isUserSessionHasFacebookAuth(user);
    if (hasFacebookAuth) {
      const transitionUser = { ...userInfo };
      return history.replace('/signin/transition', { transitionUser });
    }

    // get user avatar via provider
    const provider = await new Promise(resolve => {
      const data = {};
      const { providerData = [] } = user;
      if (!isEmpty(providerData)) {
        const { providerId, photoURL } = head(providerData);
        data.providerId = providerId;
        if (!isEmpty(photoURL)) {
          data.pic_url = providerId.includes('facebook') ? `${photoURL}?height=200` : pic_url;
        }
      }

      resolve(data);
    });

    const avatar = pic_url.replace('d1jzcuf08rvzm.cloudfront.net', 's3.amazonaws.com/soundwiseinc');
    const userObject = {
      firstName,
      lastName,
      email: head(email),
      pic_url: avatar,
      stripe_id,
      ...provider,
    };

    this.setState(userObject, () => {
      if (!isEmpty(stripe_id)) {
        this.retrieveCustomer(stripe_id);
      }
    });
  }

  retrieveCustomer(stripe_id) {
    this.setState({ loadingCustomer: true }, () => {
      Axios.get('/api/retrieveCustomer', { params: { stripe_id } })
        .then(async response => {
          const customer = response.data.customer.sources.data[0];
          this.setState({
            loadingCustomer: false,
            isCustomerLoaded: true,
            card: { ...customer },
          });
        })
        .catch(() => {
          this.setState({
            loadingCustomer: false,
          });
        });
    });
  }

  saveProfile(silent = false) {
    return new Promise(resolve => {
      const { firstName = '', lastName = '', pic_url = '' } = this.state;
      const {
        userInfo: { id: userId },
      } = this.props;

      // set default avatar if nothing was set
      const avatar = isEmpty(pic_url)
        ? 'https://s3.amazonaws.com/soundwiseinc/user_profile_pic_placeholder.png'
        : pic_url;

      this.setState({ saving: true }, async () => {
        try {
          // update db data
          await Axios.patch(`/api/user/${userId}`, {
            firstName,
            lastName,
            picURL: avatar,
          });
        } catch (err) {
          console.log('Profile save error', err.message);
        } finally {
          this.setState({ saving: false }, () => {
            if (isBoolean(silent) && silent) {
              return resolve();
            }

            this.alertDialog.showModal({
              content: 'You profile successfully updated.',
            });

            resolve();
          });
        }
      });
    });
  }

  async removeAccount() {
    const { userInfo } = this.props;
    const { publisher = {} } = userInfo;
    const { owner = '', name: publisherName = '' } = publisher;

    // set dialog title
    this.dialog.set('title', 'Remove Account');

    // if publisher and it has no owner, do not proceed
    if (!isEmpty(publisher)) {
      if (isEmpty(owner)) {
        return this.dialog
          .action('ok.text', 'OK')
          .alert(
            `Your user account cannot be deleted at this time, you're an admin of ${publisherName} and the publisher owner has yet to be identified. Please contact support.`
          );
      }

      // publisher owner should not be the same as the target user
      if (isEqual(owner, userInfo.id)) {
        return this.dialog
          .action('ok.text', 'OK')
          .alert(
            `Your user account cannot be deleted at this time because you are the primary admin of ${publisherName}.`
          );
      }
    }

    const message =
      'You are about to delete your Soundwise user account. This will go into effect immediately and you will no longer have access to your account data. If you are an admin of a publisher, you will no longer have access to the publisher data. Do you want to continue?';

    const accepted = await this.dialog.action('ok.text', 'DELETE').confirm(message);
    if (accepted) {
      const {
        history,
        userInfo: { id: userId },
        signoutUser,
      } = this.props;

      try {
        await this.removing();
        const token = await getUserSessionIdtoken(true);
        await Axios.delete(`/api/user/${userId}`, {
          headers: { token },
        });

        await authManager.signOut();
        signoutUser();
        history.push('/signin');
      } catch (err) {
        const respMessage = getPath(err, 'response.data.message', null);
        const errMessage = !isEmpty(respMessage) ? respMessage : err.message;
        console.log(errMessage);
        await new Promise(resolve => setTimeout(resolve, 450));
        await this.dialog
          .action('ok.text', 'OK')
          .alert(
            `There was an error removing your account. ${errMessage}. Please try again later.`
          );
      }

      this.removing(false);
    }
  }

  removing(value = true) {
    return new Promise(resolve => {
      this.setState(
        {
          removing: value,
        },
        resolve
      );
    });
  }

  onInputStateChange(statekey) {
    return e => {
      const value = e.target.value;
      this.setState({
        [statekey]: value,
      });
    };
  }

  renderImageCropModal() {
    const { show, onCrop, onClose, file } = this.state.imagecrop;

    return <ImageCropModal open={show} handleClose={onClose} onCrop={onCrop} file={file} />;
  }

  openImageCropModal(metadata) {
    this.setState({
      imagecrop: {
        show: true,
        onClose: this.closeImageCropModal,
        ...metadata,
      },
    });
  }

  closeImageCropModal() {
    this.openImageCropModal({
      show: false,
    });
  }

  initFilepondImageCropperFor(options) {
    this.openImageCropModal(
      options({
        close: this.closeImageCropModal,
      })
    );
  }

  isFacebooklogin() {
    const { providerId = '' } = this.state;
    return providerId.includes('facebook');
  }

  renderChangeEmail() {
    // most probably this will not detect facebook
    // since the auth transition
    const isFacebook = this.isFacebooklogin();
    const {
      userInfo: { id: userId },
    } = this.props;
    const { email } = this.state;

    return (
      <React.Fragment>
        {isFacebook && (
          <FacebookLine className="xs-margin-five-bottom">
            <div className="fb-connected" />
            <div className="text-large text-white">Connected</div>
          </FacebookLine>
        )}
        {!isFacebook && (
          <UserEmail
            userId={userId}
            email={email}
            onEmailChange={() => {
              this.alertDialog.showModal({
                content: 'You email successfully updated.',
              });
            }}
          />
        )}
      </React.Fragment>
    );
  }

  renderChangePassword() {
    // most probably this will not detect facebook
    // since the auth transition
    const isFacebook = this.isFacebooklogin();

    return (
      <React.Fragment>
        {isFacebook && (
          <FacebookLine className="xs-margin-five-bottom">
            <div className="fb-connected" />
            <div className="text-large text-white">Connected</div>
          </FacebookLine>
        )}
        {!isFacebook && (
          <UserPassword
            email={this.state.email}
            onPasswordChange={() => {
              this.alertDialog.showModal({
                content: 'You password successfully updated.',
              });
            }}
          />
        )}
      </React.Fragment>
    );
  }

  renderCreditCard() {
    const { loadingCustomer, card = {} } = this.state;
    const {
      userInfo: { id: userId },
    } = this.props;

    const getContent = () => {
      if (loadingCustomer) {
        return (
          <Loading
            text="Loading..."
            type="circle"
            align="left"
            size={20}
            fontSize={1.35}
            color="#f76b1c"
            fill="#f76b1c"
          />
        );
      }

      return (
        <UserCreditCard
          userId={userId}
          card={card}
          onBeforeCardCreated={() => this.saveProfile(true)}
          onNewCardCreated={({ card }) => {
            const ncard = { ...card.sources.data[0] };
            this.setState({ card: ncard }, this.saveProfile);
          }}
          onBillingUpdate={this.saveProfile}
        />
      );
    };

    return (
      <React.Fragment>
        <InputLabel>
          Credit Card
          <StripeMiniLogo />
        </InputLabel>
        <CreditCardLine>{getContent()}</CreditCardLine>
      </React.Fragment>
    );
  }

  createPublisherPlan() {
    this.props.history.push(`/pricing`);
  }

  renderCreatePlanContainer() {
    const { userInfo: { admin = false } } = this.props;
    if (admin) {
      return null;
    }
    return (
      <ProfileContainer className="padding-ten margin-eight-bottom">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <InputLabel> Publisher Plan </InputLabel>
          </div>
          <div className="col-lg-5 col-md-6 col-sm-12 col-xs-12">
          <CreatePlanButton onClick={this.createPublisherPlan}> Create Plan </CreatePlanButton>
          </div>
        </div>
      </ProfileContainer>
    );
  }

  renderRemoveButton() {
    const { saving = false, removing = false } = this.state;
    const removeContent = removing ? (
      <Loading
        text="Removing"
        type="circle"
        align="center"
        size={20}
        fontSize={1.5}
        color="#F44336"
        fill="#F44336"
        textStyle={{ margin: '0 5px' }}
      />
    ) : (
      'Delete Account'
    );

    return (
      <RemoveButton
        className="font-weight-600"
        onClick={this.removeAccount}
        disabled={saving || removing}>
        {removeContent}
      </RemoveButton>
    );
  }

  renderSaveButton() {
    const { saving = false } = this.state;
    const saveContent = saving ? (
      <Loading
        text="SAVING PROFILE"
        type="circle"
        align="center"
        size={20}
        fontSize={1.5}
        color="#fff"
        fill="#fff"
        textStyle={{ margin: '0 5px' }}
      />
    ) : (
      'Save Profile'
    );

    return (
      <SaveButton className="font-weight-600" onClick={this.saveProfile} disabled={saving}>
        {saveContent}
      </SaveButton>
    );
  }

  renderBody() {
    const { firstName, lastName, pic_url, email } = this.state;

    if (!userSession.ready) {
      const loadingText = 'Loading Profile';
      return (
        <LoadingWrapper height="auto">
          <Loading text={loadingText} align="center" size={50} fontSize={1.6} />
        </LoadingWrapper>
      );
    }

    return (
      <div className="container">
        <div className="row">
          <div className="col-lg-7 col-md-10 col-sm-10 col-xs-12 center-col">
            <ProfileContainer className="padding-ten margin-eight-bottom">
              <div className="row margin-five-bottom">
                <h1 className="section-title-large sm-section-title-medium xs-section-title-large font-weight-600 alt-font text-center">
                  MY PROFILE
                </h1>
              </div>
              <div className="row margin-twenty-bottom">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <AvatarUploader
                    ref={ref => (this.avatarUploader = ref)}
                    value={pic_url}
                    autoSave={false}
                    datakey="pic_url"
                    allowEdit={!this.isFacebooklogin()}
                    filename={`${firstName}-${lastName}-${moment().format('X')}`}
                    withCrop={true}
                    cropperHandler={this.initFilepondImageCropperFor}
                    onChange={(key, value) => {
                      this.setState({ [key]: value }, () => {
                        this.saveProfile();

                        // remove old profile photo
                        if (!pic_url.includes('placeholder')) {
                          this.avatarUploader.deleteFileUpload(pic_url);
                        }
                      });
                    }}
                    artStyle={{
                      wrapper: styles.profileWrapper,
                      cover: styles.profileCover,
                      button: styles.profileEditBtn,
                    }}
                    uploader={{
                      style: {
                        padding: 0,
                      },
                      options: {
                        imageValidateSizeMinWidth: 100,
                        imageValidateSizeMaxWidth: 3000,
                        imageValidateSizeMinHeight: 100,
                        imageValidateSizeMaxHeight: 3000,
                        labelIdle:
                          'Drag & Drop your profile picture or <span class="filepond--label-action"> Browse </span>',
                      },
                    }}
                  />
                </div>
              </div>
              <div className="row margin-five-bottom xs-no-margin-bottom">
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 xs-margin-ten-bottom">
                  <InputLabel>First Name</InputLabel>
                  <InputText
                    type="text"
                    onChange={this.onInputStateChange('firstName')}
                    value={firstName}
                  />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 xs-margin-ten-bottom">
                  <InputLabel>Last Name</InputLabel>
                  <InputText
                    type="text"
                    onChange={this.onInputStateChange('lastName')}
                    value={lastName}
                  />
                </div>
              </div>
              <div className="row margin-five-bottom xs-margin-ten-bottom">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <InputLabel>Email</InputLabel>
                  <InputEmail type="text" className="text-large" value={email} readonly disabled />
                </div>
              </div>
              <div className="row margin-five-bottom xs-margin-ten-bottom">
                <div className="col-lg-5 col-md-6 col-sm-12 col-xs-12">
                  {this.renderChangeEmail()}
                </div>
              </div>
              <div className="row margin-five-bottom">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  {this.renderCreditCard()}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-5 col-md-6 col-sm-12 col-xs-12">
                  {this.renderSaveButton()}
                </div>
              </div>
            </ProfileContainer>
            <ProfileContainer className="padding-ten margin-eight-bottom">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <InputLabel>Change Password</InputLabel>
                  <ChangePasswordLine className="margin-five-bottom text-medium">
                    Hint: Password should be at least six characters long. To make it stronger, use
                    upper and lower case letters, numbers, and symbols.
                  </ChangePasswordLine>
                </div>
                <div className="col-lg-5 col-md-6 col-sm-12 col-xs-12">
                  {this.renderChangePassword()}
                </div>
              </div>
            </ProfileContainer>
            {this.renderCreatePlanContainer()}
            <ProfileContainer className="padding-ten margin-eight-bottom">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <InputLabel>Delete Account</InputLabel>
                  <DeleteAccountLine className="margin-five-bottom text-medium">
                    Warning: All your account data in Soundwise will be permanently deleted.
                  </DeleteAccountLine>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                  {this.renderRemoveButton()}
                </div>
              </div>
            </ProfileContainer>
          </div>
        </div>
        <AlertDialog ref={ref => (this.alertDialog = ref)} />
        <AlertConfirmDialog ref={ref => (this.dialog = ref)} />
        {this.renderImageCropModal()}
      </div>
    );
  }

  render() {
    return (
      <FullContentWrapper>
        <SoundwiseHeader showIcon={true} />
        <FullContentSection background="#fafafa" className="padding-two">
          <MuiThemeProvider>{this.renderBody()}</MuiThemeProvider>
        </FullContentSection>
        <Footer showPricing={false} />
      </FullContentWrapper>
    );
  }
}

const styles = {
  profileWrapper: {
    width: 200,
    margin: '0 auto',
  },
  profileCover: {
    width: 200,
    height: 200,
    borderRadius: '50%',
    overflow: 'hidden',
    position: 'relative',
    border: '1px solid #c3c3c3',
  },
  profileEditBtn: {
    backgroundColor: 'rgba(7, 7, 7, 0.6)',
    width: '100%',
    height: 50,
    color: Colors.mainWhite,
    fontSize: 18,
    border: 0,
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
  },
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ signoutUser }, dispatch);
}

const mapStateToProps = state => {
  const { userInfo, isLoggedIn } = state.user;
  return { userInfo, isLoggedIn };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);
